var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 7.60001H3.2C2.5376 7.60001 2 7.06241 2 6.40001C2 5.73761 2.5376 5.20001 3.2 5.20001H24.8C25.4624 5.20001 26 5.73761 26 6.40001C26 7.06241 25.4624 7.60001 24.8 7.60001Z",
    fill: "#130F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 22.7998H3.2C2.5376 22.7998 2 22.2622 2 21.5998C2 20.9374 2.5376 20.3998 3.2 20.3998H24.8C25.4624 20.3998 26 20.9374 26 21.5998C26 22.2622 25.4624 22.7998 24.8 22.7998Z",
    fill: "#130F40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 15.1999H3.2C2.5376 15.1999 2 14.6623 2 13.9999C2 13.3375 2.5376 12.7999 3.2 12.7999H24.8C25.4624 12.7999 26 13.3375 26 13.9999C26 14.6623 25.4624 15.1999 24.8 15.1999Z",
    fill: "#130F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBars);
export default __webpack_public_path__ + "static/media/icon-bars.4a73d3f6cc852d53b8765495275bfd73.svg";
export { ForwardRef as ReactComponent };